module.exports = __webpack_public_path__ + "img/orange.1a67f715.svg";